import axios from "axios";
import { config } from '../../config/Config';

const accountUrl = `${config.serverBaseUrl}/v1/public/account`;

/**
 * Asks the server to act on a "forgot password" request.
 *
 * <p>No access token — the caller is by definition signed out, and the endpoint lives under
 * /v1/public precisely so it is reachable without one.
 *
 * <p>The response is the same for every address and says nothing about whether an account exists,
 * so there is nothing here to branch on. The server decides what to send: the reset link for an
 * account with a password, a "you sign in with Google" note for one without, and nothing for an
 * address it does not know. Telling the browser which case it was would let anyone probe this form
 * to find out which addresses have GeoPlay accounts.
 */
export const requestPasswordReset = async (email) => {
    try {
        const response = await axios({
            method: 'post',
            url: `${accountUrl}/password-reset`,
            headers: { 'Content-Type': 'application/json' },
            data: { email },
        });
        return response.data;
    } catch (error) {
        console.error('Error requesting password reset:', error.response?.data || error.message);
        throw error;
    }
};
